import React from 'react';
import './sidebar.css';
import Logo from '../../Assets/logo.svg';
import NavLinks from '../Comman/navlink';
import Icon1  from '../../Assets/Icon 1.svg';
import Icon2  from '../../Assets/Icon 2.svg';
import Icon3  from '../../Assets/Icon 3.svg';
import Icon4  from '../../Assets/Icon 4.svg';
import Icon5  from '../../Assets/Icon 5.svg';
import Icon6  from '../../Assets/Icon 6.svg';
import Icon7  from '../../Assets/Icon 7.svg';
import Icon8  from '../../Assets/Icon 8.svg';
import Icon9  from '../../Assets/Icon 9.svg';
import Icon10 from '../../Assets/Icon 10.svg';
import Icon11 from '../../Assets/Icon 11.svg';

const Sidebar = () => {
  return (
    <div className='sidebar'>
      <div className='sidebar_div1'>
        <img src={Logo} alt="Nebu logo" />
      </div>

      <nav className='sidebar_div2'>
        <NavLinks to="/dashboard"       text="Dashboard"        icon={Icon1}  />
        <NavLinks to="/bookings"        text="Bookings"         icon={Icon2}  />
        <NavLinks to="/exhibitors"      text="Exhibitors"       icon={Icon3}  />
        <NavLinks to="/tickets"         text="Tickets"          icon={Icon4}  />
        <NavLinks to="/website-content" text="Website Content"  icon={Icon5}  />
        <NavLinks to="/faq"             text="FAQ & Navigation" icon={Icon6}  />
        <NavLinks to="/popup-ads"       text="Popup Ads"        icon={Icon7}  />
        <NavLinks to="/users"           text="Users & Roles"    icon={Icon8}  />
        <NavLinks to="/media"           text="Media Library"    icon={Icon9}  />
        <NavLinks to="/analytics"       text="Analytics"        icon={Icon10} />
        <NavLinks to="/settings"        text="Event Settings"   icon={Icon11} />
      </nav>

      <div className='sidebar_div3'>
        <div className='sidebar_div3_1'>
          <div className='sidebar_profile'>
            <span style={{ color: '#0D0D0D', fontFamily: 'Inter', fontSize: 13, fontWeight: 700 }}>A</span>
          </div>
          <div className='sidbar_div3_2'>
            <h6 className='sidebar_text1'>Admin User</h6>
            <h6 className='sidebar_text2'>admin@nebu.com</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;